<template>
  <div class="row q-col-gutter-md">
    <!-- Header Section -->
    <div class="col-12">
      <div class="row q-col-gutter-md">
        <div class="col-md-6 col-12">
          <q-btn
            v-if="showCloneButton && cloneFunction"
            unelevated
            class="bg-primary-darkened text-white"
            :label="$ts('button.cloneSale')"
            @click="cloneFunction"
          ></q-btn>
        </div>
        <div v-if="salesData.category" class="col-md-6 col-12">
          <SaleType
            classes="justify-end"
            :auto-width="false"
            :rounded="false"
            size="md"
            :data="salesData.category || {}"
          ></SaleType>
        </div>
      </div>
    </div>
    <div class="col-md-8 col-12">
      <div class="row content-between q-col-gutter-md">
        <!-- Member Info Section -->
        <div class="col-md-8 col-12">
          <!--  Todo make new component for skipDownline config -->
          <q-list v-if="isSkipDownline && !hideMemberInfo" dense>
            <q-item>
              <q-item-section top side>
                {{ $t('Sales.SaleInfoSponsor.Text') }}
              </q-item-section>
              <q-item-section top side>
                {{ getSaleSponsor }}
              </q-item-section>
              <q-item-section top side>
                <div class="q-gutter-xs">
                  <q-btn
                    size="xs"
                    color="primary-darkened"
                    icon="swap_horiz"
                    unelevated
                    rounded
                    @click="activateMemberChange(memberChange)"
                  />
                  <q-btn size="xs" color="primary-darkened" icon="close" unelevated rounded @click="removeSponsor()" />
                </div>
              </q-item-section>
            </q-item>
            <q-separator v-if="salesData.sponsor_member_id === salesData.downline_member_id" />
            <q-item>
              <q-item-section>
                <Info :message="$t('Sales.SaleInfoChangeSponsorInfo.Text')"></Info>
              </q-item-section>
            </q-item>
            <q-item v-if="memberChange">
              <q-item-section class="q-my-sm">
                <q-select
                  v-model.trim="terms"
                  hide-bottom-space
                  :label="$t('members.iboIbName.placeholder.label')"
                  use-input
                  options-dense
                  dense
                  map-options
                  autofocus
                  outlined
                  :options="memberSearchList"
                  @filter="search"
                  @input="item => selected(item, 'terms')"
                >
                  <template v-slot:option="scope">
                    <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                      <q-item-section>
                        <q-item-label v-html="scope.opt.label" />
                        <q-item-label caption>{{ scope.opt.sublabel }}</q-item-label>
                      </q-item-section>
                    </q-item>
                  </template>
                  <template v-slot:no-option>
                    <q-item>
                      <q-item-section class="text-grey">
                        {{ $t('Common.NoResult.Text') }}
                      </q-item-section>
                    </q-item>
                  </template>
                </q-select>
              </q-item-section>
            </q-item>
          </q-list>
          <MemberPersonalInfo
            v-if="!hideMemberInfo"
            :personal-data="memberDetails"
            separator="none"
            :hide-fields="hideMemberInfoFields"
            :show-fields="showMemberInfoFields"
          >
            <template slot="tr-bottom">
              <slot name="member-personal-info-tr-btm"></slot>
            </template>
          </MemberPersonalInfo>
          <slot name="space-left"></slot>
        </div>
        <div class="col-md-4 col-xs-12">
          <!-- Sale Info Section -->
          <div class="row q-col-gutter-sm">
            <div v-if="showHideFields('transactionDate')" class="col-12">
              <q-input
                hide-bottom-space
                :label="$t('Sales.TransactionDate.Text')"
                dense
                outlined
                clearable
                readonly
                :value="
                  disableEditing
                    ? formatDate(salesData.transaction_date, appSettings.defaulted.date_format)
                    : getCurrentDate(appSettings.defaulted.date_format)
                "
                type="text"
              />
            </div>
            <div class="col-12">
              <q-select
                v-if="!disableEditing || locationsEditState"
                v-model="salesData.location_id"
                class="required"
                hide-bottom-space
                :label="$t('Sales.TransactionLocation.Text')"
                options-dense
                dense
                emit-value
                map-options
                outlined
                :error="validations[validationKey].location_id.$error || setError('location_id', 'type.exp')"
                :error-message="
                  validations[validationKey].location_id.$error || setError('location_id', 'type.exp')
                    ? validations[validationKey].location_id.$error
                      ? $t('Common.Missing.Text', {
                          field: $t('general.select.transactionLocation'),
                        })
                      : setError('location_id', 'type.msg')
                    : ''
                "
                clearable
                :readonly="!isValidPayLater && disableEditing"
                :disable="lockTransactionLocation"
                :options="transLocations"
                @input="$emit('setStockLocation', salesData.location_id)"
              />
              <q-input
                v-else
                hide-bottom-space
                :label="$t('Sales.TransactionLocation.Text')"
                dense
                outlined
                :value="getTransLocation"
                readonly
              />
            </div>
            <div class="col-12">
              <q-select
                v-if="(!disableEditing || locationsEditState) && !stockLocationAutoFill"
                v-model="salesData.stock_location_id"
                class="required"
                hide-bottom-space
                :label="$t('Sales.StockLocation.Text')"
                options-dense
                dense
                emit-value
                map-options
                outlined
                :error="
                  $helpers.isSet(validations, `${validationKey}.stock_location_id`) &&
                    validations[validationKey].stock_location_id.$error
                "
                :error-message="
                  $helpers.isSet(validations, `${validationKey}.stock_location_id`) &&
                  validations[validationKey].stock_location_id.$error
                    ? $t('Common.Missing.Text', { field: $t('general.select.stockLocation') })
                    : ''
                "
                clearable
                :disable="salesData.location_id === null"
                :readonly="!isValidPayLater && disableEditing"
                :options="stockLocations"
              />
              <q-input
                v-else
                hide-bottom-space
                :label="$t('Sales.StockLocation.Text')"
                :error="
                  $helpers.isSet(validations, `${validationKey}.stock_location_id`) &&
                    validations[validationKey].stock_location_id.$error
                "
                :error-message="
                  $helpers.isSet(validations, `${validationKey}.stock_location_id`) &&
                  validations[validationKey].stock_location_id.$error
                    ? $t('Common.Missing.Text', { field: $t('general.select.stockLocation') })
                    : ''
                "
                dense
                outlined
                :value="getStockLocation"
                readonly
                :hint="stockLocationAutoFill ? $t('Common.Autofill.Text', { field: '**' }) : ''"
              />
            </div>
            <div v-if="isLocationsEditable" class="col-12">
              <q-btn
                size="xs"
                class="fit"
                rounded
                unelevated
                color="primary-darkened"
                :label="locationsEditState ? 'Cancel Edit' : 'Edit Locations'"
                @click="$emit('changeLocations', locationsEditState)"
              />
            </div>
            <div
              v-if="showHideFields('payCycle')"
              v-permission:callback="{
                permission: getPermissionDirectiveCallbackString('update-payCycle'),
                callback: event => hasPermissionCheck(event, 'cwSelectionPermissionUpdate'),
              }"
              class="col-12"
            >
              <q-select
                v-if="!disableEditing || (disableEditing && salesData.is_back_date_sale && cwSelectionPermissionUpdate)"
                v-model="salesData.cw_id"
                class="required"
                hide-bottom-space
                bottom-slots
                options-dense
                dense
                emit-value
                map-options
                outlined
                :standout="commissionWeeks.length > 1"
                :bg-color="commissionWeeks.length > 1 ? 'amber-4' : 'white'"
                :error="validations[validationKey].cw_id.$error"
                :error-message="$ts('common.validation.errorMessage.cwId')"
                clearable
                :readonly="disableEditing && !salesData.is_back_date_sale && !cwSelectionPermissionUpdate"
                :options="commissionWeeks"
                :label="$t('Common.CW.Text')"
                :hide-hint="commissionWeeks.length <= 1"
                :hint="
                  salesData.is_back_date_sale || commissionWeeks.length > 1 ? $t('Common.BackDateAvailable.Text') : ''
                "
              />
              <q-input
                v-else
                hide-bottom-space
                :label="$t('Common.CW.Text')"
                dense
                outlined
                :value="$helpers.getValue(salesData, 'cw.cw_name')"
                readonly
              />
            </div>
            <div v-if="showHideFields('remarks')" class="col-12">
              <q-input
                v-model="salesData.remarks"
                hide-bottom-space
                dense
                outlined
                clearable
                :readonly="disableEditing"
                type="textarea"
                :label="isRedemption ? $t('Sales.Remarks.Text') : 'PRP point(s) has been converted to voucher(s).'"
              />
            </div>
          </div>
          <div class="row q-col-gutter-sm">
            <slot name="space-middle"></slot>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!hide" class="col-md-4 col-12">
      <div class="row justify-end q-col-gutter-md">
        <!-- CV's Section -->
        <div v-if="showCvColumns" class="col-4">
          <div class="row no-margin content-stretch full-height q-col-gutter-sm cv-boxes">
            <div
              v-for="cv in scopeGetFields(
                isEnrollment ? 'modules.enrollment.info.cvs.fields' : 'modules.sales.createUpdate.info.cvs.fields'
              )"
              class="col-12"
            >
              <span class="text-primary">{{ $t(cv.label) }}</span>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360.96 358.98">
                <text>{{ $helpers.getValue(salesData, `cvs.${cv.field}`, 0) }}</text>
              </svg>
            </div>
          </div>
        </div>
        <!-- Sale Summary Section -->
        <div class="col-8">
          <div class="row q-col-gutter-sm">
            <div class="col-12">
              <q-input
                v-model="salesData.order_fees.total_nmp"
                hide-bottom-space
                :label="$t('common.terms.totalNmp')"
                dense
                outlined
                type="number"
                readonly
                :prefix="currencyLabelByCountry"
              />
            </div>
            <div class="col-12">
              <q-input
                v-model="salesData.order_fees.admin_fee"
                hide-bottom-space
                :label="$t('common.terms.adminFee')"
                dense
                outlined
                type="number"
                :readonly="disableEditing"
                :prefix="currencyLabelByCountry"
                @input="reCalculateCart('admin_fees')"
              />
            </div>
            <div class="col-12">
              <q-input
                v-model="salesData.order_fees.delivery_fee"
                hide-bottom-space
                :label="$t('common.terms.deliveryFee')"
                dense
                outlined
                type="number"
                :readonly="disableEditing"
                :prefix="currencyLabelByCountry"
                @input="reCalculateCart('delivery_fees')"
              />
            </div>
            <div class="col-12">
              <q-input
                v-model="salesData.order_fees.other_fee"
                hide-bottom-space
                :label="$t('common.terms.otherFee')"
                dense
                outlined
                type="number"
                :readonly="disableEditing"
                :prefix="currencyLabelByCountry"
                @input="reCalculateCart('other_fees')"
              />
            </div>
            <div class="col-12">
              <q-input
                v-model="salesData.order_fees.tax_amount"
                hide-bottom-space
                :label="$t('common.terms.taxAmount')"
                dense
                outlined
                type="number"
                readonly
                :prefix="currencyLabelByCountry"
              />
            </div>
            <div class="col-12">
              <q-input
                v-model="salesData.order_fees.rounding_adjustment"
                hide-bottom-space
                :label="$t('common.terms.roundingAdjustment')"
                dense
                outlined
                type="number"
                readonly
                :prefix="currencyLabelByCountry"
              />
            </div>
            <div class="col-12">
              <q-input
                v-model="salesData.order_fees.total_gmp"
                hide-bottom-space
                :label="$t('common.terms.totalGMPAmount')"
                dense
                outlined
                type="number"
                :color="salesData.invoice_id && salesData.invoice !== null ? 'positive' : 'red-10'"
                readonly
                :prefix="currencyLabelByCountry"
              />
            </div>
            <div class="col-12">
              <slot name="space-right"></slot>
              <div v-if="isHasPendingPayment" class="animated pulse q-mt-md text-weight-bold text-primary">
                <Info :message="$t('Sales.HasPendingPayment.Text')"></Info>
              </div>
              <div v-if="isiTokenCampaign" class="animated pulse q-mt-md text-weight-bold text-info">
                <Info text-color="text-negative" :message="$ts('banner.iTokenInfo.text.message')"></Info>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { SaleType } from '../elements'
import { DatesMixin, ScopeConfigMixin, SetFormFieldErrorsMixin } from 'src/application/global/mixins'
import { mapState, mapGetters, mapActions } from 'vuex'
export default {
  name: 'SaleInfo',
  components: {
    SaleType,
  },
  mixins: [DatesMixin, ScopeConfigMixin, SetFormFieldErrorsMixin],
  props: {
    hide: {
      type: Boolean,
      default: false,
    },
    memberDetails: {
      type: Object,
    },
    salesData: {
      type: Object,
      required: true,
    },
    disableEditing: {
      type: Boolean,
      default: false,
    },
    locationsEditState: {
      type: Boolean,
      default: false,
    },
    isLocationsEditable: {
      type: Boolean,
      default: false,
    },
    isHasPendingPayment: {
      type: Boolean,
      default: false,
    },
    isValidPayLater: {
      type: Boolean,
      default: false,
    },
    lockTransactionLocation: {
      type: Boolean,
      default: false,
    },
    commissionWeeks: {
      type: Array,
      default: () => [],
    },
    validations: {
      type: Object,
    },
    validationKey: {
      type: String,
      default: 'salesData',
    },
    transLocations: {
      type: Array,
      default: () => [],
    },
    stockLocations: {
      type: Array,
      default: () => [],
    },
    getStockLocation: {
      type: String,
    },
    getTransLocation: {
      type: String,
    },
    isSkipDownline: {
      type: Boolean,
      default: false,
    },
    hideFields: {
      type: Array,
      default: () => [],
    },
    isRedemption: {
      type: Boolean,
      default: () => true,
    },
    stockLocationAutoFill: {
      type: Boolean,
      default: false,
    },
    showCvColumns: {
      type: Boolean,
      default: true,
    },
    permissions: {
      type: Object,
      default: () => ({
        operation: {
          create: {
            payCycle: 'sales.management.new|create',
          },
          update: {
            payCycle: 'sales.management.view|update',
          },
          delete: '',
          view: '',
        },
      }),
    },
    hideMemberInfo: {
      type: Boolean,
      default: false,
    },
    hideMemberInfoFields: {
      type: Array,
      default: () => [],
    },
    showMemberInfoFields: {
      type: Array,
      default: () => [],
    },
    showCloneButton: {
      type: Boolean,
      default: false,
    },
    cloneFunction: {
      type: Function,
    },
  },
  watch: {
    memberChange(to) {
      if (to) {
        this.$emit('isDirty')
      }
    },
  },
  data: () => ({
    memberChange: false,
    memberSearchList: [],
    terms: '',
    cwSelectionPermissionCreate: false,
    cwSelectionPermissionUpdate: false,
  }),
  computed: {
    ...mapState({
      membersSearchData: state => state.globalCMP.memberSearchDataGlobal.list,
    }),
    ...mapGetters(['currencyLabelByCountry']),
    getSaleSponsor() {
      return this.$helpers.getValue(this.memberDetails, 'upline.name', this.$t('Common.NotAvailable.Text'))
    },
    isiTokenCampaign() {
      return (
        this.$helpers.isSet(this.salesData, 'itoken_voucher_id', ['notNull', 'notEmpty']) ||
        (this.$helpers.isSet(this.salesData, 'campaign', ['notNull', 'notEmpty']) &&
          !this.$helpers.getValue(this.salesData, 'redeem_later'))
      )
    },
    isEnrollment() {
      return (
        this.$helpers.getValue(this.salesData, 'is_enrollment') ||
        this.$helpers.getValue(this.salesData, 'is_enrollment_sale')
      )
    },
  },
  methods: {
    ...mapActions(['getMemberSearchAction']),
    async removeSponsor() {
      await new Promise(() => {
        this.$q
          .dialog({
            title: 'Information',
            ok: 'Confirm',
            cancel: 'No',
            noBackdropDismiss: true,
            noEscDismiss: true,
            message: `Confirm Remove Sponsor`,
          })
          .onOk(() => {
            this.salesData.sponsor_member_id = ''
          })
      })
    },
    activateMemberChange(x) {
      this.memberChange = !x
      this.currentTab = 'items'
    },
    search(terms, update, abort) {
      if (terms !== '') {
        let query = {
          exclude_non_active: true,
          sponsor_id: this.salesData.sponsor_member_id,
          search_text: terms,
          limit: 10,
        }
        this.getMemberSearchAction(this.$helpers.removeFalsyValues(query)).then(() => {
          update(() => {
            this.memberSearchList = this.membersSearchData
          })
        })
      } else {
        abort()
      }
    },
    selected(item) {
      let query = { upline_id: this.memberDetails.upline.user_id, user_id: item.userID }
      this.$emit('getMember', query)
      this.salesData.downline_member_id = item.userID
      this.activateMemberChange(this.memberChange)
    },
    hasPermissionCheck(result, type) {
      this[type] = result
    },
    getPermissionDirectiveCallbackString(operation) {
      let text = ''
      let splitText = operation.split('-')
      if (splitText.length === 2) {
        text = this.permissions.operation[splitText[0]][splitText[1]] || ''
      }
      return text
    },
    showHideFields(name) {
      return !this.hideFields.includes(name)
    },
  },
}
</script>

<style scoped>
svg {
  width: 100%;
  height: auto;
}

text {
  transform: translate(20px, 200px);
  font-size: 40px;
  font-weight: bold;
  fill: #000;
}
</style>
